/**
 * Vista pública del bono · el portador escanea el QR y ve su saldo.
 * URL: /c/bono/:qr
 */
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api/client';


export default function CasetaBonoPage() {
  const { qr } = useParams();
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!qr) return;
    api.get(`/public/caseta/bono/${qr}`)
      .then((r) => setData(r.data))
      .catch((err) => setError(err.response?.data?.detail || 'Bono no encontrado'));
  }, [qr]);

  if (error) {
    return (
      <div className="min-h-screen bg-surface flex items-center justify-center p-8 text-center font-sans">
        <div>
          <h1 className="font-display font-bold text-[24px] text-ink mb-2">{error}</h1>
          <p className="text-[13.5px] text-ink-500">Pide a la caseta otro QR.</p>
        </div>
      </div>
    );
  }

  if (!data) return <div className="min-h-screen bg-surface flex items-center justify-center font-sans text-ink-500">Un momento…</div>;

  return (
    <div className="min-h-screen bg-surface text-ink font-sans antialiased">
      <main className="max-w-md mx-auto px-6 pt-10 pb-16">
        <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-ink-500 mb-2">
          · Tu bono
        </div>
        <h1 className="font-display font-bold text-[28px] text-ink mb-1 tracking-[-0.02em]">
          {data.holder_name}
        </h1>

        <div className="bg-paper border border-line shadow-card rounded-card p-7 mt-6 mb-5 text-center">
          <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-ink-500 mb-2">
            · Saldo disponible
          </div>
          <div className="font-display font-bold text-[56px] text-olive-700 tabular-nums leading-none">
            {data.balance_eur.toFixed(2)} €
          </div>
          <p className="text-[12px] text-ink-500 mt-2">
            Recargado total · {data.total_topped_up_eur.toFixed(2)} €
          </p>
        </div>

        {data.last_movements && data.last_movements.length > 0 && (
          <div className="bg-paper border border-line rounded-card p-5">
            <div className="font-mono text-[10.5px] uppercase tracking-[0.18em] text-ink-500 mb-3">
              · Últimos movimientos
            </div>
            <ul className="divide-y divide-line-soft">
              {data.last_movements.slice().reverse().map((mv: any, i: number) => (
                <li key={i} className="py-2 flex items-baseline justify-between gap-3 text-[13px]">
                  <div className="flex-1 min-w-0">
                    <div className="text-ink truncate">{mv.concept || (mv.amount > 0 ? 'Recarga' : 'Consumo')}</div>
                    <div className="text-[11px] text-ink-500">
                      {new Date(mv.at).toLocaleString('es-ES', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
                    </div>
                  </div>
                  <span className={`font-display font-bold tabular-nums ${mv.amount > 0 ? 'text-olive-700' : 'text-brick'}`}>
                    {mv.amount > 0 ? '+' : ''}{mv.amount.toFixed(2)} €
                  </span>
                </li>
              ))}
            </ul>
          </div>
        )}

        <p className="mt-6 text-[11.5px] text-ink-500 text-center font-mono uppercase tracking-wide">
          · Enseña este QR en la barra para consumir
        </p>
      </main>
    </div>
  );
}
